<template>
  <invoice-list></invoice-list>
</template>

<script>
import InvoiceList from "../../components/order/InvoiceList.vue";

export default {
  components: {
    InvoiceList
  },
  props: {
    dataChange: {
      type: Object
    }
  },
  created() {},
  destroyed() {},
};
</script>